var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "strategy-text-2-section"
  }, [_c('text-content-wrapper', {
    scopedSlots: _vm._u([{
      key: "col-1",
      fn: function () {
        return [_c('div', {
          staticClass: "heading-2",
          domProps: {
            "innerHTML": _vm._s(_vm.fields.field_one.value.text)
          }
        }), _c('div', {
          staticClass: "line-separator"
        })];
      },
      proxy: true
    }, {
      key: "col-2",
      fn: function () {
        return [_c('div', {
          staticClass: "heading-3-bold",
          domProps: {
            "innerHTML": _vm._s(_vm.fields.field_two.value.text)
          }
        })];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }